export const EXPANDED_WIDTH = 260;
export const EXPANDED_HEIGHT = 260;
export const CORNER_WIDTH = 30;
export const PADDING_HORIZONTAL = 8;
export const PADDING_VERTICAL = 10;
export const DEFAULT_TITLE_ROWS = 2;
export const DEFAULT_EMPTY_TEXT = 'Double-click to edit';
export const BODY_MARGIN_TOP = 8;
export const BODY_MARGIN_BOTTOM = 20;
